import { render } from "./NewFinanceCard.vue?vue&type=template&id=49823552&scoped=true"
import script from "./NewFinanceCard.vue?vue&type=script&lang=js"
export * from "./NewFinanceCard.vue?vue&type=script&lang=js"

import "./NewFinanceCard.vue?vue&type=style&index=0&id=49823552&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49823552"]])

export default __exports__